import _get from 'lodash/get';
import _forIn from 'lodash/forIn';
import { AbstractPlugin } from 'mlb-media-player';
import Bandwagon from 'bandwagon/bandwagon';

/**
 *
 * @module EventReplicator
 * @desc Sends specified events to the parent window
 * @class EventReplicator
 *
 */
class EventReplicator extends AbstractPlugin {

    /**
     *
     * @param {object} config
     * @param {MediaPlayer.ObservationCenter} observationCenter
     * @constructor
     *
     */
    constructor(config, observationCenter) {

        super(config, observationCenter);

        /**
         *
         * @type {Window} Reference to the current parent window
         *
         */
        this.parentWindow = _get(config, 'parentWindow', window.parent);

        /**
         *
         * @type {Bandwagon} bandwagon event bus, created using the `bandwagonKey` config value
         *
         */
        this.dispatcher = Bandwagon.getInstanceByKey(`#${_get(config, 'bandwagonKey', 'video-player')}`);

        /**
         *
         * @type {string} the playerId to reference in the replicated message
         *
         */
        this.playerId = _get(config, 'playerId', 'video-player');

        /**
         *
         * @type {array} List of events to replicate
         *
         */
        this.events = _get(config, 'eventsToReplicate', []);

        this.replicate();

    }

    replicate() {

        _forIn(this.events, (eventName) => {

            /**
             *
             * if I see a mediaStartEvent, I'm re-sending metaData there's a weird VAST/VPAID ad thing that makes MOAT go
             * crazy and the MetaDataEvent gets eaten by the AdEvents, so this is a workaround.
             *
             */
            this.dispatcher.on(eventName, (data, event) => {

                //console.log("event.post: ", event.type, event);
                this.parentWindow.postMessage({
                    type: event.type,
                    playerId: this.playerId,
                    payload: !!data ? this.removeCircularReferences(eventName, data) : undefined,
                }, '*');

            });

        });

    }

    removeCircularReferences(eventName, object) {

        const cache = [];
        const replacer = (key, value) => {

            if (typeof value === 'function' || value === undefined || value === null || value instanceof Window) {

                return;

            }

            if (value instanceof Object) {

                if (cache.indexOf(value) > -1) {

                    return;

                }

                cache.push(value);

            }

            return value;

        };

        //don't pass around player
        if (object && object.player) {

            const playerId = object.player.id;

            object.player = { id: playerId };

        }

        try {

            return JSON.parse(JSON.stringify(object, replacer));

        } catch (e) {

            console.log('removeCircularReferences: error replicating event: ', eventName, e);

            return {};

        }

    }

}

export default EventReplicator;
